import React from "react";
import {
  Box,
  Typography,
  Paper,
  Grid,
  Card,
  CardContent,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  ConfirmationNumber as TicketIcon,
  Person as PersonIcon,
  AttachMoney as MoneyIcon,
} from "@mui/icons-material";

const RevenueStatistics = ({ dashboardData, formatCurrency }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (!dashboardData) {
    return (
      <Typography variant="body1" color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
        Brak danych do wyświetlenia
      </Typography>
    );
  }

  return (
    <>
      {/* Summary Cards */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        {/* Total Revenue */}
        <Grid item xs={12} sm={6} md={4}>
          <Card sx={{ height: '100%', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <MoneyIcon sx={{ color: 'white', mr: 1 }} />
                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.9)' }}>
                  Całkowity przychód
                </Typography>
              </Box>
              <Typography variant="h4" sx={{ color: 'white', fontWeight: 700 }}>
                {formatCurrency(dashboardData.total_revenue)}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Passes Sold */}
        <Grid item xs={12} sm={6} md={4}>
          <Card sx={{ height: '100%', background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)' }}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <TicketIcon sx={{ color: 'white', mr: 1 }} />
                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.9)' }}>
                  Sprzedane karnety
                </Typography>
              </Box>
              <Typography variant="h4" sx={{ color: 'white', fontWeight: 700 }}>
                {dashboardData.pass_statistics.count}
              </Typography>
              <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.8)', mt: 1 }}>
                {formatCurrency(dashboardData.pass_statistics.total_revenue)}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Single Entries */}
        <Grid item xs={12} sm={6} md={4}>
          <Card sx={{ height: '100%', background: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)' }}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <PersonIcon sx={{ color: 'white', mr: 1 }} />
                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.9)' }}>
                  Wejścia jednorazowe
                </Typography>
              </Box>
              <Typography variant="h4" sx={{ color: 'white', fontWeight: 700 }}>
                {dashboardData.single_entry_statistics.count}
              </Typography>
              <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.8)', mt: 1 }}>
                {formatCurrency(dashboardData.single_entry_statistics.total_revenue)}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Revenue Breakdown */}
      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
          Podział przychodów
        </Typography>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} sm={6}>
            <Box sx={{ p: 2, bgcolor: '#f5f5f5', borderRadius: 2 }}>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Przychód z karnetów
              </Typography>
              <Typography variant="h5" sx={{ fontWeight: 600, color: '#4facfe' }}>
                {formatCurrency(dashboardData.pass_statistics.total_revenue)}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                {dashboardData.total_revenue > 0
                  ? `${((dashboardData.pass_statistics.total_revenue / dashboardData.total_revenue) * 100).toFixed(1)}% całkowitego przychodu`
                  : '0% całkowitego przychodu'}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box sx={{ p: 2, bgcolor: '#f5f5f5', borderRadius: 2 }}>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Przychód z wejść jednorazowych
              </Typography>
              <Typography variant="h5" sx={{ fontWeight: 600, color: '#fa709a' }}>
                {formatCurrency(dashboardData.single_entry_statistics.total_revenue)}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                {dashboardData.total_revenue > 0
                  ? `${((dashboardData.single_entry_statistics.total_revenue / dashboardData.total_revenue) * 100).toFixed(1)}% całkowitego przychodu`
                  : '0% całkowitego przychodu'}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </>
  );
};

export default RevenueStatistics;
